import { render, staticRenderFns } from "./posTerminalTransactions.vue?vue&type=template&id=2fd875ac&"
import script from "./posTerminalTransactions.vue?vue&type=script&lang=js&"
export * from "./posTerminalTransactions.vue?vue&type=script&lang=js&"
import style0 from "./posTerminalTransactions.vue?vue&type=style&index=0&id=2fd875ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports